/* JAPOKE TCG theme scripts */
(function () {
  var JP = window.JP || {};
  var root = (JP.routes && JP.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = html;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* ---------- Cart state ---------- */
  var cart = JP.cart || { item_count: 0, items: [], total_price: 0 };

  function qtyFor(variantId) {
    var q = 0;
    cart.items.forEach(function (i) { if (String(i.variant_id) === String(variantId)) q += i.quantity; });
    return q;
  }

  function renderCart() {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count || ''; el.dataset.count = cart.item_count; });
    $$('.stepper[data-variant]').forEach(function (s) {
      var q = qtyFor(s.dataset.variant);
      $('[data-qty]', s).textContent = q;
      s.classList.toggle('has-qty', q > 0);
    });
    var bar = $('[data-shipbar]');
    if (bar) {
      var goal = Number(bar.dataset.goal) || 0;
      var left = Math.max(goal - cart.total_price, 0);
      $('.shipbar__fill', bar).style.width = (goal ? Math.min(cart.total_price / goal, 1) * 100 : 100) + '%';
      $('[data-shipbar-text]', bar).innerHTML = left > 0
        ? '<b>' + money(left) + '</b> ' + (S.away || 'away from free shipping')
        : '<b>' + (S.free || 'Free shipping') + '</b> ' + (S.unlocked || 'unlocked');
    }
  }

  // Mirrors Shopify's money placeholders, incl. the comma/space styles used for NOK (kr 1 499,00).
  function money(cents) {
    var fmt = JP.moneyFormat || '${{amount}}';
    function group(value, decimals, thousands, decimal) {
      var parts = (value / 100).toFixed(decimals).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var map = {
      amount: group(cents, 2, ',', '.'),
      amount_no_decimals: group(cents, 0, ',', '.'),
      amount_with_comma_separator: group(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: group(cents, 0, '.', ','),
      amount_with_space_separator: group(cents, 2, ' ', ','),
      amount_no_decimals_with_space_separator: group(cents, 0, ' ', ','),
      amount_with_apostrophe_separator: group(cents, 2, "'", '.')
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) { return key in map ? map[key] : map.amount; }).replace(/<[^>]+>/g, '');
  }
  JP.money = money;
  JP.renderCart = function () { renderCart(); };
  var S = JP.strings || {};

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function refreshCart() {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { cart = c; renderCart(); return c; });
  }

  // Preview mode (no Shopify backend): keep a fake cart in memory.
  function previewChange(id, qty, price) {
    var item = cart.items.filter(function (i) { return String(i.variant_id) === String(id); })[0];
    if (!item) { item = { variant_id: id, quantity: 0, price: price || 0 }; cart.items.push(item); }
    item.quantity = Math.max(qty, 0);
    cart.item_count = cart.items.reduce(function (a, i) { return a + i.quantity; }, 0);
    cart.total_price = cart.items.reduce(function (a, i) { return a + i.quantity * i.price; }, 0);
    return Promise.resolve(cart);
  }

  function setQty(id, next, price) {
    if (JP.preview) return previewChange(id, next, price).then(renderCart);
    var current = qtyFor(id);
    var req = next > current && current === 0
      ? post(root + 'cart/add.js', { items: [{ id: Number(id), quantity: next }] })
      : post(root + 'cart/change.js', { id: String(id), quantity: next });
    return req.then(refreshCart);
  }

  function addedToast() {
    toast((S.added || 'Added to cart') + ' · <a href="' + root + 'cart">' + (S.viewCart || 'View cart') + '</a>');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.stepper [data-step]');
    if (!btn) return;
    var s = btn.closest('.stepper');
    var id = s.dataset.variant;
    var next = Math.max(qtyFor(id) + Number(btn.dataset.step), 0);
    s.classList.add('is-busy');
    setQty(id, next, Number(s.dataset.price))
      .then(function () {
        if (Number(btn.dataset.step) > 0) addedToast();
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || S.error || 'Could not update cart'); })
      .then(function () { s.classList.remove('is-busy'); });
  });

  /* ---------- AJAX product form ---------- */
  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (JP.preview) { e.preventDefault(); addedToast(); return; }
      e.preventDefault();
      var btn = $('[type=submit]', form);
      btn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .then(refreshCart)
        .then(addedToast)
        .catch(function (err) { toast((err && err.description) || S.error || 'Could not add to cart'); })
        .then(function () { btn.disabled = false; });
    });
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.qty [data-qty-step]');
    if (!b) return;
    var input = $('input', b.closest('.qty'));
    var v = Math.max((Number(input.value) || 0) + Number(b.dataset.qtyStep), Number(input.min || 0));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant pills: price + availability ---------- */
  $$('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    picker.addEventListener('change', function (e) {
      var opt = e.target;
      var priceBox = $('[data-price-box]');
      if (priceBox) {
        $('.now', priceBox).textContent = opt.dataset.price;
        var was = $('.was', priceBox);
        was.textContent = opt.dataset.compare || '';
        priceBox.classList.toggle('is-sale', !!opt.dataset.compare);
      }
      var submit = $('[type=submit]', form);
      if (submit) {
        submit.disabled = opt.dataset.available !== 'true';
        submit.textContent = submit.disabled ? submit.dataset.soldText : submit.dataset.addText;
      }
      if (opt.dataset.image) {
        var main = $('.gallery__main img');
        if (main) main.src = opt.dataset.image;
      }
      if (window.history.replaceState && !JP.preview) {
        var url = new URL(window.location.href); url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* ---------- Gallery thumbs ---------- */
  $$('.gallery__thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      $('.gallery__main img').src = b.dataset.src;
      $$('.gallery__thumbs button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
    });
  });

  /* ---------- Hero slider ---------- */
  $$('[data-slider]').forEach(function (el) {
    var track = $('.hero__track', el);
    var slides = $$('.slide', track);
    var dots = $('.hero__dots', el);
    var i = 0, timer;
    if (slides.length < 2) { $$('.hero__arrow', el).forEach(function (a) { a.hidden = true; }); return; }
    slides.forEach(function (_, n) {
      var d = document.createElement('button');
      d.type = 'button'; d.setAttribute('aria-label', 'Slide ' + (n + 1));
      d.addEventListener('click', function () { go(n); });
      dots.appendChild(d);
    });
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      $$('button', dots).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      restart();
    }
    function restart() {
      clearInterval(timer);
      var sec = Number(el.dataset.autoplay);
      if (sec) timer = setInterval(function () { go(i + 1); }, sec * 1000);
    }
    $('.hero__arrow--prev', el).addEventListener('click', function () { go(i - 1); });
    $('.hero__arrow--next', el).addEventListener('click', function () { go(i + 1); });
    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', restart);
    go(0);
  });

  /* ---------- Countdown ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) { el.hidden = true; return; }
    function tick() {
      var s = Math.max(Math.floor((end - Date.now()) / 1000), 0);
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var pad = function (n) { return String(n).padStart(2, '0'); };
      el.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Announcement close ---------- */
  $$('.announce__close').forEach(function (b) {
    b.addEventListener('click', function () {
      b.closest('.announce').remove();
      try { sessionStorage.setItem('jp-announce-closed', '1'); } catch (e) {}
    });
  });
  try { if (sessionStorage.getItem('jp-announce-closed')) $$('.announce').forEach(function (a) { a.remove(); }); } catch (e) {}

  /* ---------- Header toggles ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]');
    if (!t) return;
    var target = $(t.dataset.toggle);
    if (!target) return;
    var open = target.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open);
    if (open) { var f = $('input', target); if (f) f.focus(); }
  });

  /* ---------- Collection: auto-submit filters ---------- */
  $$('form[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) { if (e.target.matches('select, input[type=checkbox]')) form.submit(); });
  });

  /* ---------- Cart page: auto-update quantities ---------- */
  $$('form[data-cart-form] .qty input').forEach(function (input) {
    var t;
    input.addEventListener('change', function () { clearTimeout(t); t = setTimeout(function () { input.form.submit(); }, 500); });
  });

  /* ---------- Language: remember manual choice, auto-pick on first visit ---------- */
  var LANG_KEY = 'jp-lang-chosen';
  function remember() { try { localStorage.setItem(LANG_KEY, '1'); } catch (e) {} }
  function base(code) {
    var b = String(code || '').toLowerCase().split('-')[0];
    return (b === 'no' || b === 'nn') ? 'nb' : b; // Norwegian browsers report no / nb / nn
  }
  function switchLanguage(form, code) {
    if (JP.preview && JP.setLang) { JP.setLang(code); return; }
    var input = document.createElement('input');
    input.type = 'hidden'; input.name = 'language_code'; input.value = code;
    form.appendChild(input);
    form.submit();
  }
  $$('#lang-form .lang__btn').forEach(function (b) {
    b.addEventListener('click', function (e) {
      remember();
      if (JP.preview) { e.preventDefault(); switchLanguage(b.form, b.value); }
    });
  });
  (function autoLanguage() {
    var form = $('#lang-form');
    var header = $('[data-auto-language]');
    if (!form || (header && header.dataset.autoLanguage === 'false')) return;
    if (/bot|crawl|spider|slurp/i.test(navigator.userAgent)) return; // keep search engines on the default language
    try { if (localStorage.getItem(LANG_KEY)) return; } catch (e) { return; }
    remember(); // only ever auto-switch once, so we never loop or fight the visitor
    var available = $$('.lang__btn', form).map(function (b) { return b.value; });
    var prefs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (var i = 0; i < prefs.length; i++) {
      var want = base(prefs[i]);
      var match = available.filter(function (code) { return base(code) === want; })[0];
      if (match) {
        if (base(match) !== base(JP.locale)) switchLanguage(form, match);
        return;
      }
    }
  })();

  renderCart();
})();
